import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { confirmPasswordReset } from '../services/auth';
import PasswordInput from './PasswordInput';
import '../pages/Login.css'  ;              // reuse your login page styles
// import './ResetPassword.css';      // add only the overrides below

export default function ResetPassword() {
  const { uid, token } = useParams();
  const navigate = useNavigate();

  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [pwdError, setPwdError] = useState('');
  const [matchError, setMatchError] = useState('');
  const [infoMsg, setInfoMsg] = useState('');

  const validate = () => {
    if (newPassword.length < 8) {
      setPwdError('Password must be at least 8 characters.');
      return false;
    }
    setPwdError('');

    if (newPassword !== confirmPassword) {
      setMatchError('Passwords do not match.');
      return false;
    }
    setMatchError('');

    return true;
  };

  const handleReset = async () => {
    if (!validate()) return;

    try {
      await confirmPasswordReset({ uid, token, new_password: newPassword });
      setInfoMsg('Password has been reset! Redirecting to login...');
      setTimeout(() => navigate('/login'), 2000);
    } catch {
      setInfoMsg('Invalid or expired link.');
    }
  };

  return (
    <div className="login-container">
      <div className="login-box reset-box">
        <img src="/logo.png" alt="Goldfish Logo" className="login-logo" />
        <h2 className="login-title">Reset Password</h2>

        <PasswordInput
          className="login-input"
          placeholder="New password"
          value={newPassword}
          onChange={e => {
            setNewPassword(e.target.value);
            setPwdError('');
          }}
        />
        {pwdError && <p className="error">{pwdError}</p>}

        <PasswordInput
          className="login-input"
          placeholder="Confirm new password"
          value={confirmPassword}
          onChange={e => {
            setConfirmPassword(e.target.value);
            setMatchError('');
          }}
        />
        {matchError && <p className="error">{matchError}</p>}

        <button
          onClick={handleReset}
          className="login-button"
          disabled={!newPassword || !confirmPassword}
        >
          Reset Password
        </button>

        {infoMsg && <p className="info">{infoMsg}</p>}
      </div>
    </div>
  );
}
